<template>
  <div v-if="currentQuery" class="queries -new">
    <h1 class="page-title">
      <router-link to="/queries">Queries</router-link>
      <span class="divider">&rsaquo;</span>
      {{ currentQuery.label }}
    </h1>

    <query-form
      v-if="currentQuery"
      :query="currentQuery"
      :form-state="formState"
      :errors="errors"
      :button-text="'Update Query'"
      @changeMade="changeMade"
      @submit="update"
      @revertState="formState = 'normal'"
    ></query-form>
  </div>
</template>

<script>
import { mapState } from "vuex";

import queryForm from "@/components/queryForm/main";
import auth from "@/helpers/auth";

export default {
  components: { queryForm },
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  beforeRouteLeave(to, from, next) {
    this.ensureFormSaved(next);
  },

  beforeRouteUpdate(to, from, next) {
    this.ensureFormSaved(next);
  },

  data() {
    return {
      formState: "normal",
      errors: {},
      changesMade: false
    };
  },

  computed: {
    ...mapState({
      queries: (state) => state.queries.all,
      currentQuery: (state) => state.queries.current
    })
  },

  watch: {
    queries() {
      this.setCurrentQuery();
    },

    $route(to, from) {
      this.setCurrentQuery();
    },

    currentQuery() {
      this.$nextTick(() => {
        this.changesMade = false;
      });
    }
  },

  created() {
    if (this.queries.length) this.setCurrentQuery();
  },

  methods: {
    setCurrentQuery() {
      this.$store.dispatch("changeCurrentQuery", this.$route.params.id);
    },

    update(params) {
      this.formState = "loading";

      this.$store
        .dispatch("updateQuery", params)
        .then((resp) => {
          this.formState = "done";
          this.errors = {};
          this.changesMade = false;
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.formState = "normal";
        });
    },

    ensureFormSaved(next) {
      if (!this.changesMade || confirm("Unsaved changes will be lost, are you sure you want to leave?")) next();
    },

    changeMade() {
      this.changesMade = true;
    }
  }
};
</script>
